export const testimonials = [
  {
    id: '1',
    name: '小宇',
    location: '上海',
    content: '通过男同网的活动信息，我参加了去年的骄傲月活动，认识了很多志同道合的朋友。这个平台真的让我感受到了社群的温暖。',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20Asian%20male%20portrait%20with%20warm%20smile%20on%20soft%20peach%20gradient%20background%20minimal%20portrait%20photography%20clean&width=120&height=120&seq=testi-01&orientation=squarish',
  },
  {
    id: '2',
    name: '阿豪',
    location: '北京',
    content: '健康指南板块的文章帮我建立了定期体检的习惯。以前总是忽视健康问题，现在每年都会按时检查，感谢平台的科普。',
    avatar: 'https://readdy.ai/api/search-image?query=Confident%20Asian%20male%20portrait%20with%20sincere%20smile%20on%20soft%20coral%20gradient%20background%20minimal%20portrait%20photography%20clean&width=120&height=120&seq=testi-02&orientation=squarish',
  },
  {
    id: '3',
    name: 'Ryan',
    location: '广州',
    content: '出柜后感到很迷茫，在社群里看到了很多相似经历的朋友分享的故事，给了我很大的勇气。现在我也在帮助其他刚出柜的朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20Asian%20male%20portrait%20with%20hopeful%20expression%20on%20soft%20golden%20gradient%20background%20minimal%20portrait%20photography%20clean&width=120&height=120&seq=testi-03&orientation=squarish',
  },
];